module.exports = __webpack_public_path__ + "static/assets/cbcc0bfacdd2e5303c468c3c2cfaaf29.svg";